module.exports = __webpack_public_path__ + "img/aeroland-pricing-image-05.7c9cfd41.png";